// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"batch-entry-close-and-export__button___28Bkj"};
    if(module.hot) {
      // 1701915842335
      var cssReload = require("../../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  